<template>
  <q-dialog ref="dialogRef">
    <q-card style="min-width: 500px" square>
      <q-card-section class="text-h5">Välj tåg</q-card-section>
      <q-separator />
      <q-card-section>
        <q-table
          :columns="columns"
          :rows="rowsWithUuid"
          flat
          row-key="uuid"
          @row-click="handleSelect"
        >
          <template #bottom></template>
        </q-table>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { AvikGraphTimetableItem } from '@/api/graph/getAvikGraphTimetable'
import { v4 as uuid } from 'uuid'
import { useDialogPluginComponent } from 'quasar'
import { useGraphCirculation } from '@/composable/useGraphCirculation'

export default defineComponent({
  name: 'SelectGraphTrainModal',

  emits: [...useDialogPluginComponent.emits],

  props: {
    options: {
      type: Array as PropType<AvikGraphTimetableItem[]>,
      default: () => [],
    },
  },

  setup(props) {
    const rowsWithUuid = props.options.map((x) => {
      return { ...x, uuid: uuid() }
    })
    const { setSelectedTrainNumber } = useGraphCirculation()

    const { dialogRef, onDialogOK } = useDialogPluginComponent()

    const handleSelect = async (
      _evt: Event,
      selectedTrain: AvikGraphTimetableItem
    ) => {
      await setSelectedTrainNumber(
        selectedTrain.core,
        selectedTrain.departureDate
      )
      onDialogOK([selectedTrain])
    }

    const columns = [
      {
        label: 'Core',
        field: 'core',
        name: 'core',
        align: 'left',
        sortable: false,
      },
      {
        label: 'Sökande',
        field: 'owner',
        name: 'owner',
        align: 'left',
        sortable: false,
      },
      {
        label: 'Operatör',
        field: 'operator',
        name: 'operator',
        align: 'left',
        sortable: false,
      },
    ]

    return { columns, rowsWithUuid, handleSelect, dialogRef }
  },
})
</script>

<style scoped></style>
